import { render, staticRenderFns } from "./CenarioBotoes.vue?vue&type=template&id=0300fa56&scoped=true&"
import script from "./CenarioBotoes.vue?vue&type=script&lang=js&"
export * from "./CenarioBotoes.vue?vue&type=script&lang=js&"
import style0 from "./CenarioBotoes.vue?vue&type=style&index=0&id=0300fa56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0300fa56",
  null
  
)

export default component.exports